// extracted by mini-css-extract-plugin
export default {"FPL":"FPL_FPL__M00Tk"};